
<div class="w-100">
    <c-drop-message
        v-if     = "drag.notAllowed"
        :message ="drag.message"
        style="margin-left: 0"
    />

    <drop
        v-if          = "bid"
        class         = "cut h-100 w-100"
        @drop         = "onDropBid"
        mode          = "cut"
        :accepts-type = "onAcceptTypeBid"
        :accepts-data = "() => bid.status.id !== 0"
        ref ="droparea"
    >
        <div class="bid-panel">
            <div
                v-if  = "bid.favorite"
                class = "favorite primary white--text v-flex"
                style = "border-radius: 4px"
            >
                <span><i class="fas fa-star pr-1"></i>{{ $t("repair.bid.label.favorite") }}</span>
            </div>
            <div v-if="!bid.favorite" class="not-favorite primary--text">
                <v-menu
                    v-model="favoriteselect"
                    offset-y
                    :close-on-content-click="false"
                    class="pa-0"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div class="v-flex">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                depressed
                                color="white"
                                class="pr-8"
                            >
                                <span><i class="far fa-star"></i></span>

                                <v-checkbox
                                    class="mr-0"
                                    :ripple="false"
                                    color="primary"
                                    v-model="bid.active"
                                    @click.stop="onBid"
                                />

                                <div class="primary--text" style="margin-left: -10px;">
                                    {{ bidname }}
                                </div>
                                <v-spacer />
                            </v-btn>
                        </div>
                    </template>

                    <div class="favorite-query-container">
                        <div>{{ $t("repair.bid.query.favorite") }}</div>
                        <div class="query-buttons">
                            <v-btn
                                rounded
                                width="100"
                                color="primary"
                                @click="onFavorite"
                            >{{ $t("common.yes") }}
                            </v-btn>
                            <div style="width: 10px"></div>
                            <v-btn
                                rounded
                                width="100"
                                @click="favoriteselect=false"
                            >{{ $t("common.no") }}
                            </v-btn>
                        </div>
                    </div>
                </v-menu>
            </div>

            <c-flip-card
                v-model  = "flipped"
                :top     = "top"
                :right   = "10"
                :color   = "bid.favorite?'white--text':'#0a68b8'"
                :enabled = "bid.active"
            >
                <template v-slot:front>
                    <div class="bid-front white">
                        <v-row class="no-frame mt-2" v-show="!bid.active && hasDocuments(bid.active)">
                            <v-col class="no-frame error--text">
                                {{ $t("repair.bid.document.deletehint") }}
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-1 mb-2 lm-border pl-2 pr-2" v-show="bid.active">
                            <v-col class="no-frame">
                                <inc-status
                                    :items  = "bidstatus"
                                    v-model = "bid.status"
                                    class   = "mt-2 mb-3"
                                    :hide-details = "true"
                                    :background = "collective ? 'field-group-background-blue' : ''"
                                    @change = "onStatusChange"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame  lm-border">
                            <v-col class="no-frame">
                                <v-row
                                    class="no-frame"
                                    v-show="bid.active"
                                >
                                    <v-col class="no-frame">
                                        <inc-manufacturer
                                            class="pa-2 pt-1 pb-0"
                                            v-model = "bid.manufacturer"
                                            :hint   = "manufacurerHint"
                                            :rules  = "[requiredRule]"
                                            @input  = "onManfacturerChange"
                                            :background = "sites.length > 1 ? 'field-group-background-blue' : ''"
                                        />
                                    </v-col>
                                </v-row>

                                <v-row class="no-frame" v-show="bid.active" style="height: 105px">
                                    <c-contact-select
                                        v-if        = "bid.manufacturer"
                                        v-model     = "bid.contactIds"
                                        label       = "Kontakte"
                                        class       = "w-100 pl-2 pr-2 mt-n1"
                                        :company-id = "bid.manufacturer ? bid.manufacturer.id : null"
                                        :incident   = "incident"
                                        :index      = "index"
                                        :status     = "bid.status"
                                        :background = "collective ? 'field-group-background-blue' : 'white'"
                                        @sendmail   = "onSendmail"

                                    />
                                </v-row>
                            </v-col>
                        </v-row>


                        <v-row class="no-frame mt-2 lm-border pa-2 pt-1 pb-3" v-show="bid.active">
                            <v-col class="no-frame mr-2">
                                <v-text-field
                                    :label         = "$t('repair.bid.label.number')"
                                    v-model        = "bid.number"
                                    :rules         = "[requiredRule]"
                                    :background-color = "sites.length > 1 ? 'field-group-background-blue' : ''"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    hide-details
                                />
                            </v-col>
                            <v-col class="no-frame ml-2">
                                <f-enum-select
                                    v-model   = "bid.deliverytime"
                                    :label    = "$t('invoice.deliverytimes')"
                                    :readonly = "readonly"
                                    module    = "inc"
                                    type      = "deliverytimes"
                                    :background = "sites.length > 1 ? 'field-group-background-blue' : ''"
                                    hide-details
                                />
                            </v-col>
                        </v-row>

                        <div v-if="bid.active && sites.length > 1" class="mt-6 mb-3">
                            <inc-calculation-sum
                                :calculations = "bid.calculations"
                                :navigation   = "true"
                                :collective   = "collective"
                                :border       = "true"
                                @navigate     = "onZoom"
                            />
                        </div>

                        <div v-if="bid.active" class="mt-6">
                            <inc-calculation
                                v-if="bidUnitData"
                                :form     = "form"
                                :data     = "bidUnitData"
                                :status   = "bid.status"
                                :favorite = "bid.favorite"
                                :notice   = "sites.length === 0"
                                :title    = "'Kalkulation Anlage ' + $store.getters.site.fabricNo"
                                :border   = "true"
                                :compact="false"
                            />
                        </div>
                    </div>
                </template>
                <template v-slot:back>
                    <div class="white" style="height: calc(100% - 10px); width: calc(100% + 1px)">
                        <inc-bid-documents
                            v-if           = "data && bid.status.id !== 0"
                            :collection-id = "data.id"
                            :bid-id        = "bid.id"
                            :bid-name      = "bidname"
                            :data          = "data"
                            ref            = "biddocs"
                        />
                    </div>
                </template>
            </c-flip-card>
        </div>
    </drop>
</div>
